import { render, staticRenderFns } from "./DocumentsLayout.vue?vue&type=template&id=69de66f0&"
import script from "./DocumentsLayout.vue?vue&type=script&lang=js&"
export * from "./DocumentsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports